module.exports = __webpack_public_path__ + "static/img/4_10commitments_100000tonnes.7a45ae1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/4_10commitments_100000tonnes.jpg
// module id = gO1H
// module chunks = 0